import {
  Add,
  CalendarMonth,
  CheckCircleOutline,
  Delete,
  DeleteForever,
  DevicesOtherOutlined,
  DoNotDisturb,
  DriveFileMove,
  Edit,
  GroupWorkOutlined,
  MoreVert,
  Person2Outlined
} from '@mui/icons-material'

export const AddAliasIcon = Add
export const RescheduleIcon = CalendarMonth
export const EnableAliasIcon = CheckCircleOutline
export const RemoveAliasIcon = Delete
export const PermanentDeleteIcon = DeleteForever
export const OtherGroupIcon = DevicesOtherOutlined
export const DisabledAliasIcon = DoNotDisturb
export const MoveAliasIcon = DriveFileMove
export const EditAliasIcon = Edit
export const AllGroupIcon = GroupWorkOutlined
export const AliasMenuIcon = MoreVert
export const PersonGroupIcon = Person2Outlined
